import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const OfferingPageContainer = styled.div<{ theme: { token: GlobalToken } }>`
  padding: ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.paddingSM}px;

  .ant-tabs {
    .ant-tabs-tabpane {
      display: flex;
    }

    .ant-tabs-nav {
      .ant-tabs-nav-wrap {
        display: flex;
        justify-content: center;

        .ant-tabs-tab {
          flex-grow: 0;
        }

        .ant-tabs-ink-bar {
          background-color: ${({ theme: { token } }) => token.colorPrimary};
          height: 3px;
          border-radius: 5px 5px 0 0;
        }
      }

      .bold-text {
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      }
    }
  }

  .system-view-payment-plan-card {
    position: relative;
    top: unset;
    left: unset;
    transform: unset;
    margin-top: ${({ theme: { token } }) => token.marginXXL}px;
    height: 723px;
  }

  .payment-plan-card {
    position: relative;
    top: unset;
    left: unset;
    transform: unset;
  }
`;

export const ResponsiveContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: scroll;
  height: calc(100vh - 80px);

  @media (min-width: 1679px) {
    flex-direction: row;
  }
`;
